import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Grid, Row, Col, Alert, Button } from 'react-bootstrap'

import { LoadingSpinner, WizardSteps } from '../../components'
import { createBadge, updateBadge, setErrors } from '../actions'
import { linkPaths } from '../urls'
import BadgeName from './BadgeName'
import BadgeReviewImage from './BadgeReviewImage'
import ReviewContentLayout from './ReviewContentLayout'

class Review extends React.Component {
  static propTypes = {
    history: PropTypes.object,
    badgeInfo: PropTypes.object.isRequired,
    finishBadge: PropTypes.func.isRequired,
    updateBadge: PropTypes.func.isRequired,
    clearErrors: PropTypes.func.isRequired,
    selectedChapters: PropTypes.array.isRequired,
    selectedAssessments: PropTypes.array.isRequired,
    selectedVideos: PropTypes.array.isRequired,
    passingScore: PropTypes.string.isRequired,
    errors: PropTypes.array.isRequired,
    retrievedEditData: PropTypes.bool.isRequired,
  }

  state = {
    is_finishing: false,
  }

  componentWillUnmount() {
    this.props.clearErrors()
  }

  goBack = e => {
    e.preventDefault()
    let { history } = this.props
    history.push(linkPaths.requirements)
  }

  finish = e => {
    e.preventDefault()
    this.setState({ is_finishing: true })
    if (this.props.retrievedEditData) {
      this.props.updateBadge({
        ...this.props.badgeInfo,
        chapters: this.props.selectedChapters,
        assessments: this.props.selectedAssessments,
        videos: this.props.selectedVideos,
        passingScore: this.props.passingScore,
      })
    } else {
      this.props.finishBadge({
        ...this.props.badgeInfo,
        chapters: this.props.selectedChapters,
        assessments: this.props.selectedAssessments,
        videos: this.props.selectedVideos,
        passingScore: this.props.passingScore,
      })
    }
  }

  formatErrors = () => {
    if (this.props.errors.length === 0) {
      return
    }
    return (
      <Grid>
        <Row>
          <Col xs={24} sm={12} smOffset={6}>
            <Alert bsStyle="danger">
              <ul>
                {this.props.errors.map((msg, i) => (
                  <li key={i}>{msg}</li>
                ))}
              </ul>
            </Alert>
          </Col>
        </Row>
      </Grid>
    )
  }

  render() {
    return (
      <div>
        <WizardSteps
          edit={this.props.retrievedEditData}
          step={3}
          linkPaths={linkPaths}
          heading="Badge"
          subHeading="Review"
        />
        <div className="review_container">
          {this.formatErrors()}
          <div className="flex_container">
            <div id="badge_review_box">
              <div className="text-center" id="badge_name">
                <BadgeName disable />
              </div>
              <div id="images">
                <div className="image" id="incompleteImage">
                  Incomplete Icon
                  <BadgeReviewImage
                    imageLoaded={this.props.badgeInfo.incompleteImageLoaded}
                    image={this.props.badgeInfo.incompleteImage}
                    imageName={this.props.badgeInfo.incompleteImageName}
                    imageType="Incomplete"
                  />
                </div>
                <div className="image" id="completeImage">
                  Complete Icon
                  <BadgeReviewImage
                    imageLoaded={this.props.badgeInfo.completeImageLoaded}
                    image={this.props.badgeInfo.completeImage}
                    imageName={this.props.badgeInfo.completeImageName}
                    imageType="Complete"
                  />
                </div>
              </div>
            </div>
            <ReviewContentLayout />
          </div>
          <div className="btn_container">
            <Button bsStyle="primary" onClick={this.goBack}>
              Back
            </Button>
            <Button
              bsStyle="primary"
              disabled={this.props.errors.length > 0}
              onClick={this.finish}
            >
              <span>Finish</span>{' '}
              {this.state.is_finishing && this.props.errors.length === 0 ? (
                <LoadingSpinner
                  style={{ fontSize: '1em', color: 'white' }}
                  outerClass={'inline'}
                />
              ) : (
                ''
              )}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    badgeInfo: state.badgeInfo,
    selectedChapters: state.badgeInfo.selectedChapters,
    selectedAssessments: state.badgeInfo.selectedAssessments,
    selectedVideos: state.badgeInfo.selectedVideos,
    passingScore: state.badgeInfo.passingScore,
    errors: state.errors,
    retrievedEditData: state.badgeInfo.retrievedEditData,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    finishBadge: badgeInfo => {
      dispatch(createBadge(badgeInfo))
    },
    updateBadge: badgeInfo => {
      dispatch(updateBadge(badgeInfo))
    },
    clearErrors: () => {
      dispatch(setErrors([]))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Review)
